import { useEffect } from "react";

const SITE = "https://www.onkaal.com";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO({ title, description, path = "", schema }) {
  const schemaStr = schema ? JSON.stringify(schema) : "";
  useEffect(() => {
    const full = title ? `${title} | Onkaal.com` : "Onkaal.com | Home Services at Your Doorstep across India";
    document.title = full;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", full);
    setMeta("property", "og:url", `${SITE}${path}`);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (canon) canon.setAttribute("href", `${SITE}${path}`);
    let tag = document.getElementById("page-schema");
    if (tag) tag.remove();
    if (schemaStr) {
      tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.id = "page-schema";
      tag.text = schemaStr;
      document.head.appendChild(tag);
    }
  }, [title, description, path, schemaStr]);
}
